import {
  useState,
  useMemo
} from '@wordpress/element';
import { SelectControl } from '@wordpress/components';

const TypeSelection = props => {
  const {
    Component,
    onChange,
    options,
    value
  } = props;

  const [type, setType] = useState( options[0].value );
  const [param, setParam] = useState( parseInt(value) );

  useMemo( () => {
    onChange( param+type );
  }, [param, type]);

  const boxStyles = {
    margin: '20px 0',
    padding: '20px',
    border: '1px solid grey',
  };

  const spaceBetweenComponentsStyle = {
    marginTop: '-20px'
  }; 

  return (
    <div style={ boxStyles }>
      <Component
        {...props}
        onChange={ setParam }
        value={ param }
      />
      <div style={ spaceBetweenComponentsStyle } />
      <SelectControl
        options={ options }
        value={ type }
        onChange={ setType }
      />
    </div>
  );
}

export default TypeSelection;